@if (showButton$ | async) {
  @if (isMobile$ | async) {
    <fcom-icon-button
      [dataTestId]="'finnair-plus-login-button'"
      [finElemTracker]="(loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'open-login' : 'open-profile'"
      [finElemContext]="trackingContext"
      [finElemType]="ElementTypes.BUTTON"
      [aria]="{
        label:
          ((loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'login.openLogin' : 'login.displayProfile')
          | finLocalization,
        role: 'button',
      }"
      [icon]="icon$ | async"
      [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
      data-hj-suppress
    />
  } @else {
    <fcom-button
      [class]="'login-btn'"
      data-testid="finnair-plus-login-button"
      [finElemTracker]="(loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'open-login' : 'open-profile'"
      [finElemContext]="trackingContext"
      [finElemType]="ElementTypes.BUTTON"
      [aria]="{
        label:
          ((loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'login.openLogin' : 'login.displayProfile')
          | finLocalization,
        role: 'button',
      }"
      [icon]="{
        ...(icon$ | async),
        position: IconPosition.LEFT,
      }"
      [text]="
        showName && (loginStatus$ | async) === LoginStatus.LOGGED_IN
          ? (profileName$ | async)
          : showName
            ? ('navigation.login' | finLocalization)
            : ''
      "
      [mode]="ButtonMode.INLINE"
      [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      data-hj-suppress
      data-dd-privacy="hidden"
    />
  }
}
